export default __webpack_public_path__ + "49fd5499db62ed54438fe6909777601f.png";